import React from "react";
import SyncLoader from "react-spinners/SyncLoader";
import { withTheme } from "styled-components";

function Loader({ isLoading, theme }) {
  return <SyncLoader size={15} color={theme.colors.pink} loading={isLoading} />;
}
export default withTheme(Loader);
